<template>
    <aside class="popup frontend-style" @click.self="cancel">
        <div class="popBox" :class="Classname">
            <slot name="contact">

            </slot>
            <slot name="language">

            </slot>
            <slot name="product">

            </slot>
            <slot name="pdf">

            </slot>
            <slot name='category'>

            </slot>
            <div v-if="$route.query.Popup=='dm'" class="viewer">
                <div v-if="currentPage != numPages" class="Loading">
                    <b-spinner></b-spinner>
                    <h5>Loading {{Math.floor(currentPage*100/numPages)}}%</h5>
                    
                </div>
                <pdf
                    v-for="i in numPages"
                    :key="i"
                    :src="src"
                    :page="i"
                    @page-loaded="showProgress"
                >
                </pdf>
            </div>
        </div>
    </aside>
</template>
<script>
import {mapState} from 'vuex'
import pdf from 'vue-pdf'
// var loadingTask = pdf.createLoadingTask('./static/soonport.pdf');

export default {
    name:'Popup',
    props:{
        Switch:Boolean,
        Classname:String
    },
    components:{
        pdf
    },
    data(){
        return{
            src: './static/soonport.pdf',
            currentPage:0,
            numPages:18,
        }
    },
    mounted() {
            // this.src.promise.then(pdf => {
            //     this.numPages = pdf.numPages;
            // });
    },
    methods: {
        cancel(){
            this.$emit('outCancel','cancel')
        },
        showProgress(val){
            this.currentPage = val
        }
    }
}
</script>